<!--
 * @FileDescription: 已出账的账单详情
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :title="$t('IssuedDetailsDialog.BillingInformation')" :visible.sync="visible" width="980px" :before-close="close">
    <div class="top">
      <p>
        <span>
          <span class="label">{{ $t('IssuedDetailsDialog.BillID') }}: </span>
          <span class="value">{{ defaultTips(info.billId) }}</span>
        </span>
      </p>
      <p>
        <span>
          <span class="label">{{ $t('IssuedDetailsDialog.BillsAmount') }}: </span>
          <span class="value">
            <span class="add"></span>
            <span>US${{ defaultTips(info.amount) }}</span>
          </span>
        </span>
        <span class="paid">
          <span class="label">{{ $t('IssuedDetailsDialog.PaymentAmount') }}: </span>
          <span class="value">
            <span class="add"></span>
            <span>US${{ defaultTips(info.paidAmount) }}</span>
          </span>
        </span>
        <span class="paid">
          <span class="label">{{ $t('IssuedDetailsDialog.PaymentDate') }}: </span>
          <span class="value">
            <span class="add"></span>
            <span>{{ defaultTips(formatTimeStamp(info.paymentDate)) }}</span>
          </span>
        </span>
      </p>
    </div>

    <el-table v-loading="loading" :data="bills" row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}px`">
      <el-table-column :label="$t('IssuedDetailsDialog.OrderID')">
        <template v-slot="{ row }">
          {{ defaultTips(row.kkOrderId) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('IssuedDetailsDialog.ParcelCode')">
        <template v-slot="{ row }">
          {{ defaultTips(row.packId) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('IssuedDetailsDialog.TableColumnPaidAmount')">
        <template v-slot="{ row }">
          {{ amount(row.amount) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('IssuedDetailsDialog.DeliveryTime')">
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.deliveryDate)) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('IssuedDetailsDialog.Status')">
        <template v-slot="{ row }">
          {{ row.fulfillmentStatus || '-' }}
          <!-- <span v-if="row.fulfillmentStatus === 'fully_shipped'" class="fulfillment-status">{{ $t('IssuedDetailsDialog.Shippped') }}: </span>
          <span v-else>-</span> -->
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/util/moment'

export default {
  data() {
    return {
      visible: false,

      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 380,

      loading: false,
      info: {
        billId: undefined, // 账单号
        amount: undefined, // 应收款
        paidAmount: undefined, // 已付款
        paymentDate: undefined // 付款时间
      },
      bills: [],
      total: 0
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 根据账单ID获取账单详情
     *
     * @param {String} billId 账单ID
     */
    async getBillDetailsById(billId) {
      try {
        this.loading = true
        let { data } = await API.getBillDetailsById(billId)
        this.bills = data.list
        this.total = data.total
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    show(payload) {
      this.visible = true
      this.info.billId = payload.billId
      this.info.amount = payload.amount
      this.info.paidAmount = payload.paidAmount
      this.info.paymentDate = payload.paymentDate
      this.getBillDetailsById(payload.billId)
    },

    save() {
      this.close()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.info = {
        billId: undefined,
        amount: undefined,
        paidAmount: undefined,
        paymentDate: undefined
      }
      this.bills = []
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-weight: 700;
}

.top {
  color: #10141d;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 18px;
  p {
    &:nth-child(1) {
      margin-bottom: 12px;
    }
    .label {
      font-weight: 600;
    }
    .paid {
      display: inline-block;
      margin-left: 128px;
    }
    .add {
      color: #99c41c;
      margin-right: 5px;
    }
  }
}

.fulfillment-status {
  position: relative;
  color: #99c41c;
  &::after {
    position: absolute;
    top: 50%;
    left: -10px;
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: #99c41c;
  }
}
</style>
